import { createSelector } from 'reselect'
export const getAllOrderItems = state => state.cart.orderItems

export const hasBackorderedItem = createSelector(getAllOrderItems, orderItems => {
  return orderItems.map(orderItem => orderItem.sku.erpQoh && orderItem.sku.erpQoh < 1).filter(orderItem => orderItem).length > 0
})
